import { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants, DISCOUNT_TYPES } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import CustomLoader from "../component/menu/CustomLoader";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import OrderFormHeaderComponent from "../component/OrderFormHeaderComponent";
import OrderPaymentItemsComponent from "../component/restaurants/orders/OrderPaymentItemsComponent";
import OrderPaymentFormComponent from "../component/restaurants/orders/OrderPaymentFormComponent";
import { getOrderSnapshotForPayment, getQueryParamsPaymentForm, initOrderEditTableSession } from "../services/order-table-base-service";
import { formatAsOrderListFromOrderDetails, redirectToTargetPage } from "../services/order-common-service";
import { defaultSummaryData, getFormatedFood, getSummaryData } from "../services/order-payment-service";
import { updateGuestNumber } from "../utils/store-mutator.table-management";

const discountTypes = [DISCOUNT_TYPES[1], DISCOUNT_TYPES[0]];

export default function OrderPayment() {
  const navigate = useNavigate();
  const { user,  showNotification, setNetworkCall } = useUserStore();
  const params = useParams();
  const {dataSource, isTableManagement} = getQueryParamsPaymentForm();
  const { orderId } = params;

  const [orderRecord, setOrderRecord] = useState({});
  const [foods, setFoods] = useState([]);
  const [summary, setSummary] = useState({...defaultSummaryData})
  const [defaultDiscountTypes, setDefaultDiscountTypes] = useState(discountTypes);


  async function getOrder(orderId) {
    setNetworkCall(true)
    const token = user.token.token;
    const res = await ApiService.FETCH_ORDER_DETAILS(orderId, token);

    setNetworkCall(false);

    if (res.code !== 200) {
      showNotification("Failed to fetch order details.");
      return null;
    }
    const formatedData = formatAsOrderListFromOrderDetails(res.payload.record)
    const formatedFoods = getFormatedFood(res.payload.record.foods);
    setFoods(formatedFoods);
    setSummary(getSummaryData(formatedData));
    setOrderRecord(formatedData);
    initOrderEditTableSession(formatedData.orderId, res.payload.record.tables, res.payload.record.orderType, isTableManagement);
    updateGuestNumber(formatedData.guests);

    if (formatedData.discountApplicablePrice === 0) {
      setDefaultDiscountTypes([DISCOUNT_TYPES[0]]);
    }
  }
  
  function reviveOrderSnapshotData() {
    const orderData = getOrderSnapshotForPayment(orderId);
    setOrderRecord(orderData);
  }

  const onActionTakenPaymentButtons = (actionType, params) => {
    if (['PAYMENT_DONE', 'PAYMENT_CANCEL', 'GUEST_BILL'].includes(actionType)) {
      redirectToTargetPage(navigate);
      return;
    }
  }
  
  useEffect(() => {
    getOrder(orderId);
    // TODO: for performance data source LOCAL should be used. It is function only set menu and proper testing needed
    // if (dataSource === 'LOCAL') {
    //   reviveOrderSnapshotData();
    // } else {
    // }
  }, [orderId, dataSource]);

  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      <CustomLoader />
      <Header title={""} menu={constants.MENU.ORDER} currentMenuKey={"T_4_S_4"} />
      <div className={`flex flex-row bg-prewhite`}>
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.ORDER} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
          <div className="flex flex-col w-full">
            <OrderFormHeaderComponent
              context={'PAYMENT'}
              title={`Payment for Order ${Boolean(orderRecord.orderNumber) ? `(${orderRecord.orderNumber})` : ""}`}
            />
            <div className="">
              <div className="flex gap-8 items-stretch">
                {Object.keys(orderRecord).length > 3 && 
                <OrderPaymentFormComponent order={orderRecord}  onPaymentParentActionHandler={onActionTakenPaymentButtons} defaultDiscountTypes={defaultDiscountTypes}/>
                }

                <OrderPaymentItemsComponent context={'PAYMENT'} orderStatus={orderRecord.status} summary={summary} foods={foods} onUpdateFoodSelection={() => {}}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
